// extracted by mini-css-extract-plugin
export default {"search":"searchDoctor_search__lo+XX"};